import * as ACTION from '../actions/actionTypes';
import { UpdateObject } from '../../utils/utils';

const initialState = {
    loading: false,
    errorMsg: '',
    data:[],
   // calendarData:[]
}

const AverageNetworkSpeedReducer = (state = initialState, action) => {
    switch(action.type) {
       
        case ACTION.GET_AVERAGE_NETWORK_SPEED_REQUEST: return getAverageNetworkSpeedRequest(state, action);
        case ACTION.GET_AVERAGE_NETWORK_SPEED_SUCCESS: return getAverageNetworkSpeedSuccess(state, action);
        case ACTION.GET_AVERAGE_NETWORK_SPEED_FAILURE: return getAverageNetworkSpeedFailure(state, action);
        
        default: return state;
    }
}

const getAverageNetworkSpeedRequest = (state, action) => {
    return UpdateObject(state, {
        loading: true,
    });
}
const getAverageNetworkSpeedSuccess = (state, action) => {
    return UpdateObject(state, {
        loading: false,
        data: action.payload,
    });
}
const getAverageNetworkSpeedFailure = (state, action) => {
    return UpdateObject(state, {
        loading: false,
        errorMsg: action.payload,
    });
}

export default AverageNetworkSpeedReducer;